import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["shouldFetchInitialData"];
import { compose, withProps } from 'recompose';
import ReactSelect from 'react-select';
import _noop from 'lodash/noop';

// utils
import pure from '@tekion/tekion-base/utils/pure';

// Containers
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import withVirtualized from './withVirtualized';
import withMultiSelect from '../multiSelect/withMultiSelect';
import withFetchAsyncResource from '../advancedSelect/containers/withAsyncResource/withFetchAsyncResource';
import withAsyncSelect from '../advancedSelect/containers/withAsyncSelect';

// Components
import { Select } from '../advancedSelect';
export default compose(withMultiSelect, withVirtualized)(Select);
export var withMultiSelectInitialFetch = function withMultiSelectInitialFetch(Component) {
  var ComponentToRender = withMultiSelect(Component);
  return pure(withProps(function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT,
      _ref$shouldFetchIniti = _ref.shouldFetchInitialData,
      shouldFetchInitialData = _ref$shouldFetchIniti === void 0 ? true : _ref$shouldFetchIniti,
      restProps = _objectWithoutProperties(_ref, _excluded);
    return {
      initialize: shouldFetchInitialData ? restProps.loadOptions : _noop
    };
  })(ComponentToRender));
};

// cannot use BaseSelect from advancedSelect as withFetchAsyncResource is incompatible
export var VirtualizedMultiAsync = compose(withFetchAsyncResource, withMultiSelectInitialFetch, withAsyncSelect, withVirtualized)(ReactSelect);
export var VirtualizedAsyncSelect = compose(withFetchAsyncResource, withAsyncSelect, withVirtualized)(ReactSelect);